export default __webpack_public_path__ + "static/tutorialPicture4-2babf35ed965865f836abd39881c3348.jpg";